export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },

  getTranslationLanguages($state) {
    return $state.languages;
  },
};
